export class CostRevColumnsData {
  public static getCBLCostRevenueColumn = (chargeCodes: string[] = [], isSummaryTable = false, isColumnSortEnabled:boolean, pageMode: boolean = true) => {
    const data = [{
      headerClassName: 'data-table header'+(!isColumnSortEnabled?' no-sorting':''),
      show: true,
      isActionLink: isSummaryTable,
      accessor: 'materialCode',
      editOptions: chargeCodes?.length>0?[...chargeCodes]:null,
      fieldHeader: 'Charge Item'
    }, {
      headerClassName: 'data-table header'+(!isColumnSortEnabled?' no-sorting':''),
      show: true,
      accessor: 'materialDescription',
      fieldHeader: 'Item Desc'
    },
    {
      headerClassName: 'data-table header'+(!isColumnSortEnabled?' no-sorting':''),
      show: true,
      accessor: 'rate',
      fieldHeader: 'Unit price',
      footer: null,
      sortable: isColumnSortEnabled,
      dataType: 'number'
    }, {
      headerClassName: 'data-table header'+(!isColumnSortEnabled?' no-sorting':''),
      show: true,
      accessor: 'condCurrency',
      fieldHeader: 'Currency',
      footer: null,
      sortable: isColumnSortEnabled
    },
    {
      headerClassName: 'data-table header'+(!isColumnSortEnabled?' no-sorting':''),
      accessor: 'quantity',
      fieldHeader: 'Quantity',
      show: true,
      footer: null,
      sortable: isColumnSortEnabled,
      dataType: 'number'
    },
    {
      headerClassName: 'data-table header'+(!isColumnSortEnabled?' no-sorting':''),
      show: true,
      accessor: 'unitOfMeasure',
      fieldHeader: 'Unit of Meassure',
      footer: null,
      sortable: isColumnSortEnabled
    },
    {
      headerClassName: 'data-table header fixedNumber no-sorting',
      className: 'deleteButton',
      show: pageMode,
      accessor: 'delete',
      isActionLink: true,
      id: 'exportJobNumber-col-link',
      fieldHeader: '',
      sortable: false
    }]
    return [...data]
  }
}
export default CostRevColumnsData